<div class="container">
  <div
    class="register"
    #registerContainer
    matTooltip="{{ regionsToString() }}"
    matTooltipPosition="left"
    matTooltipClass="ellipsed-text-mattooltip"
  >
    {{ regionsToString() }}
  </div>
  @if (isOverflowing()) {
  <div class="link">
    <a
      class="view-all-regions"
      (click)="openViewAllRegionsDialog()"
      i18n="@@RegionRendererViewAllRegionsButton"
      >View All Regions</a
    >
  </div>
  }
</div>
